import { render } from "./PageRepasseAtendimentoPaciente.vue?vue&type=template&id=6b3ae02f&scoped=true"
import script from "./PageRepasseAtendimentoPaciente.vue?vue&type=script&lang=js"
export * from "./PageRepasseAtendimentoPaciente.vue?vue&type=script&lang=js"

import "./PageRepasseAtendimentoPaciente.vue?vue&type=style&index=0&id=6b3ae02f&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3ae02f"]])

export default __exports__